import { Done } from './Done'
import { Error } from './Error'
import { Busy} from './Busy'
import { Form } from './Form'
import { Header } from './Header'

export const Component = { Header, Form, Done, Error, Busy }
